// extracted by mini-css-extract-plugin
module.exports = {"nowrap":"room__styles__nowrap___2mWf46","truncateTail":"room__styles__truncateTail___3ENSJC"};